// Single source of truth for social profiles. Update URLs here and everywhere reflects.
export const SOCIAL_LINKS = {
  facebook: {
    label: "Facebook",
    handle: "Midemide Logistics",
    url: "https://www.facebook.com/profile.php?id=61591454773125",
  },
  instagram: {
    label: "Instagram",
    handle: "@midemide277",
    url: "https://www.instagram.com/midemide277",
  },
  linkedin: {
    label: "LinkedIn",
    handle: "Midemide Logistics",
    url: "https://www.linkedin.com/company/midemide-logistics",
  },
  tiktok: {
    label: "TikTok",
    handle: "@midemidelogistics",
    url: "https://www.tiktok.com/@midemidelogistics",
  },
};
